import type { JSX } from 'solid-js';
import { Field } from './Field';
import { Select, type SelectOption } from './Select';

export function RepoEnablementFilterSelect(props: {
  readonly id: string;
  readonly label: string;
  readonly value: string;
  readonly options: readonly SelectOption<string>[];
  readonly onChange: (value: string) => void;
}): JSX.Element {
  return (
    <Field id={props.id} label={props.label}>
      {(a11y) => (
        <Select
          a11y={a11y}
          label={props.label}
          value={props.value}
          options={props.options}
          onChange={props.onChange}
          block
        />
      )}
    </Field>
  );
}
